import { create } from "zustand";
import { api } from "api";
import { usePersistentFetch } from "stores/utils/usePersistentFetch";

const useStore = create((set) => ({
  placeholders: null,
  dict: null,
  isFetched: false,
  setPlaceholdersState: (data) => {
    set({ placeholders: data.placeholders, dict: data.dict, isFetched: true });
  },
}));

const useMessagesPlaceholders = () => {
  const setPlaceholdersState = useStore((state) => state.setPlaceholdersState);
  const placeholders = useStore((state) => state.placeholders);
  const isFetched = useStore((state) => state.isFetched);

  const { fetchState } = usePersistentFetch({
    isFetched,
    setStoreData: setPlaceholdersState,
    fetchFn: api.messages.fetchPlaceholders,
    queryKey: "messages-placeholders",
  });

  return {
    placeholders,
    fetchState,
  };
};
export { useMessagesPlaceholders };
